import { bootstrapApplication } from '@angular/platform-browser';

import { logError, redirectLegacyHashRoute } from '@shared/utils';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

redirectLegacyHashRoute();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  logError('Angular bootstrap error:', err)
);
